module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("ck5Uv"))).then(() => parcelRequire('hEqeo'));